import React from 'react';
import createForm from "./Form";

class purchaseitemForm extends React.Component {

    render() {
        return (
            <div/>
        );
    }
}

export default createForm(purchaseitemForm);
